<div *ngIf="shouldShow" class="poll-item">
  <div class="poll-item-description-holder">
    <span class="poll-item-question">
      {{choice.name === '' ? '?' : choice.name}}
    </span>
  </div>
</div>
